import { render, staticRenderFns } from "./MemolanguageFlytogetSignupView.vue?vue&type=template&id=3c123608&scoped=true&"
import script from "./MemolanguageFlytogetSignupView.vue?vue&type=script&lang=js&"
export * from "./MemolanguageFlytogetSignupView.vue?vue&type=script&lang=js&"
import style0 from "./MemolanguageFlytogetSignupView.vue?vue&type=style&index=0&id=3c123608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c123608",
  null
  
)

/* custom blocks */
import block0 from "./MemolanguageFlytogetSignupView.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports